/* ============================================================
   component-header-sticky-fix.js

   On product pages we hide the announcement bar via CSS
   (visibility: hidden, height: 0). That leaves the header
   element near the very top of the viewport, which causes a
   race between the IntersectionObserver in the sticky-header
   custom element and the scroll handler. Sometimes the
   .shopify-section-header-sticky class never gets added when
   the user scrolls, so the menu bar stays transparent.

   Belt-and-braces fix: maintain a body.scrolled class purely
   from scrollY, which our CSS pairs with a rule that turns the
   header white on .template-product.scrolled. This runs
   independently of the existing sticky-header logic so the
   normal hide/reveal behavior continues to work.
   ============================================================ */
(function () {
  'use strict';

  if (!document.body || !document.body.classList) return;

  function update() {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (y > 1) {
      document.body.classList.add('scrolled');
    } else {
      document.body.classList.remove('scrolled');
    }
  }

  // Run once on load to set the initial state.
  update();

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  /* ----------------------------------------------------------
     v134 desktop megamenu fix.

     On desktop the sticky-header element adds
     .shopify-section-header-hidden (translateY(-100%)) after a
     downward scroll, lifting the whole header off-screen. Once
     it is off-screen the nav links are no longer under the
     cursor, so hover/mouseenter can never fire and the menu
     stays dead until you scroll back up. On desktop we never
     want the header fully hidden, so strip that class whenever
     it appears.

     Collection and product pages re-render DOM (filters,
     infinite scroll, quickbuy) which can replace the header
     node, so we must NOT cache a single element or watch one
     fixed node. Instead we re-query the header on every scroll
     tick and also keep a document-level observer that re-checks
     after any DOM mutation. The normal sticky white-bar behavior
     (.shopify-section-header-sticky) is left untouched, so the
     bar still stays pinned and expands on hover. Desktop only;
     mobile keeps the original hide-on-scroll behavior.
     ---------------------------------------------------------- */
  var DESKTOP_BP = 1024;
  function isDesktop() {
    return window.matchMedia('(min-width: ' + DESKTOP_BP + 'px)').matches;
  }
  function unhideHeader() {
    if (!isDesktop()) return;
    var headers = document.querySelectorAll('.shopify-section-header-hidden');
    for (var i = 0; i < headers.length; i++) {
      headers[i].classList.remove('shopify-section-header-hidden');
    }
  }

  // Enforce on every scroll tick (re-queries each time, so it
  // keeps working even if the header node was swapped out).
  window.addEventListener('scroll', unhideHeader, { passive: true });

  // Backup: re-check after any DOM change anywhere on the page,
  // covering header re-renders from section rendering.
  var docObserver = new MutationObserver(unhideHeader);
  docObserver.observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
    childList: true
  });

  unhideHeader();
})();
